import type { MenuSection } from '../types/hours'

export const foodSections: MenuSection[] = [
  {
    title: 'Griddle Toast',
    items: [
      { name: 'Avocado Muffin', price: 7 },
      { name: 'Toasted English Muffin, Butter & Jam', price: 4 },
      { name: 'Turkey, Crispy Onion & Arugula English Muffin', price: 7 },
      { name: 'Salmon, Crispy Onion & Arugula English Muffin', price: 9 },
      {
        name: 'Cream Cheese, Cucumber, Crispy Onion & Arugula English Muffin',
        price: 6,
      },
    ],
  },
  {
    title: 'Wings',
    items: [
      { name: 'Lemon Pepper Wings', price: 13, note: 'Comes with ranch dressing' },
      {
        name: 'Hot Pepper Wings',
        price: 14,
        note: 'Smothered in Basin Breeze hot sauce',
      },
    ],
  },
  {
    title: 'Chopped Sandwiches',
    note: 'Served on a crunch roll with pub cheese, crispy onion & arugula',
    items: [
      { name: 'Grilled Beef Sandwich', price: 15 },
      { name: 'Grilled Turkey Sandwich', price: 13 },
      { name: 'Grilled Mushroom Sandwich', price: 13 },
    ],
  },
  {
    title: 'Salads',
    items: [
      { name: 'Turkey Pavilion Caesar', price: 12 },
      { name: 'Salmon Pavilion Caesar', price: 14 },
    ],
  },
  {
    title: 'Waterfront Udon',
    items: [
      { name: 'Mushroom Udon', price: 12 },
      { name: 'Turkey Udon', price: 12 },
      { name: 'Beef Udon', price: 14 },
    ],
  },
  {
    title: 'Snacks',
    items: [
      { name: 'Sweet Potato Fries', price: 7, note: 'Comes with ranch dressing' },
      { name: 'Chips', price: 3 },
      { name: 'Pavilion Chocolate Popcorn', price: 4 },
    ],
  },
]

export const beverageSections: MenuSection[] = [
  {
    title: 'Hot',
    items: [
      { name: 'Latte', price: 5 },
      { name: 'Matcha Latte', price: 6 },
      { name: 'Black Sesame Latte', price: 5 },
      { name: 'Cardamom Ginger Latte', price: 6 },
      { name: 'Local Mocha', price: 6 },
      { name: 'Cappuccino', price: 5 },
      { name: 'Coffee', price: 3 },
      { name: 'Hot Tea', price: 3 },
    ],
  },
  {
    title: 'Cold',
    items: [
      { name: 'Fresh Lemonade', price: 5 },
      { name: 'Iced Tea', price: 3 },
      { name: 'Assorted Can Soda', price: 3 },
    ],
  },
]
